import { combineReducers } from "redux";
import { applications } from "./applications";
import { directory } from "./directory";
import { environments } from "./environments";
import { flags } from "./flags";
import { infrastructureApplications } from "./infrastructure-applications";
import { landingZoneRoles } from "./landing-zone-roles";
import { network } from "./network";
import { roles } from "./roles";
import { session } from "./session";
import { settings } from "./settings";
import { user } from "./user";
import { user_ids } from "./user_ids";
import { user_settings } from "./user_settings";
import { user_delegates } from "./user_delegates";

export const reducers = combineReducers({
  applications,
  environments,
  flags,
  infrastructureApplications,
  landingZoneRoles,
  network,
  roles,
  user,
  user_ids,
  directory,
  settings,
  session,
  user_settings,
  user_delegates,
});
